module.exports = __webpack_public_path__ + "static/img/yule_video.1aa6ae79.png";